import { createDefaultTyrann } from '@apis/common';
import { notification, notificationPages, notificationSearchQuery } from '@models/Notification';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const patchNotificationsBody = t.partial(notification.props);

export type PatchNotificationsBody = t.TypeOf<typeof patchNotificationsBody>;

export const notificationApis = createDefaultTyrann({
  '/notification/': {
    get: {
      query: notificationSearchQuery,
      response: {
        200: notificationPages,
      },
    },
    patch: {
      body: patchNotificationsBody,
      response: {
        200: notification,
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/notification/{id}/': {
    patch: {
      path: t.type({
        id: t.number,
      }),
      body: t.type({
        has_read: t.boolean,
      }),
      response: {
        200: notification,
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/notification/unread-count/': {
    get: {
      response: {
        200: t.type({
          unread_count: t.number,
        }),
      },
    },
  },
});
